<div class="contactUsPopup">
    <form [formGroup]="feedbackForm" (submit)="onSubmitClick()" *ngIf="!feedbackSubmitted">
      <div class="contactUsHeader">
        <h2>結果は正確でしたか？</h2>
        <span class="like-dislike-container">
          <span [ngClass]="[isLiked ? 'selected-btn' : '', 'feedback-like-icon']" (click)="isLiked = true"></span>
          <span [ngClass]="[!isLiked ? 'selected-btn' : '', 'feedback-dislike-icon']" (click)="isLiked = false"></span>
        </span>
      </div>
      <div class="contactUsBody">
        <h3>使用した入力テキストについて教えてください。</h3>
        <ul>
          <li *ngFor="let option of options; index as index">
            <span [ngClass]="[selectedOptionNumber === index ? 'selected-option' : '', 'feedback-option']" (click)="selectedOptionNumber = index">
                <span class="feedback-option-checkbox"></span>
                <span class="feedback-option-txt">{{option.text}}</span>
            </span>
          </li>
        </ul>
        <textarea matInput formControlName="feedbackText" placeholder="ご意見やご感想はございますか？"
        class="feedback-textarea"></textarea>
      </div>
      <div class="contactUsFooter">
        <button class="contactusCloseButton" mat-button mat-dialog-close>キャンセル</button>
        <button type="submit" class="contactUsSubmitButton" [disabled]="selectedOptionNumber === -1">送信</button>
      </div>
    </form>
    <div class="feedbackThankYou" *ngIf="feedbackSubmitted">
      <div class="SVGwrapper">
        <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"> <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/> <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>
      </div>
      <h2 class="animate__animated animate__fadeInUp animate__delay-1s">フィードバックをお寄せいただきありがとうございました。</h2>
      <button class="contactusCloseButton animate__animated animate__fadeInUp animate__delay-1s" class="contactusCloseButton" mat-button mat-dialog-close>閉じる</button>
    </div>
  </div>
  